import {
  assocPath,
  curry,
  difference,
  filter,
  length,
  lens,
  map,
  path,
  pickBy,
  prop,
  reduce,
  set,
  view,
} from 'ramda';
import { ERROR } from 'translations';

import { GLOBAL_ERROR } from '../../actions/errors';
import { compact, isNotVoid } from '../../helpers/compact';
import { ExtendableError, getErrorObject } from '../../helpers/error';
import {
  convertTypeToFailure,
  oneOfLoadSingleDocumentType,
  oneOfLoadPaginateSuccessType,
  oneOfLoadSuccessTypes,
} from '../common';

import { validateByType } from './lexers/by-type';

export class ValidationError extends ExtendableError {}

const selector = ({ id, type }) =>
  lens(path([type, id]), assocPath([type, id]));

const validate = curry((state, document) => {
  if (validateByType(view(selector(document), state))) {
    return document;
  }

  return null;
});

const cleanse = (state, document) => set(selector(document), null, state);

const ensureCorrectData = (payload) => {
  const { result: unsafeResult, entities: unsafeEntities } = payload;

  const result = filter(Boolean, map(validate(unsafeEntities), unsafeResult));

  const removed = difference(unsafeResult, result);
  const entities = pickBy(
    isNotVoid,
    map(compact, reduce(cleanse, unsafeEntities, removed))
  );

  return {
    ...payload,
    result,
    entities,
  };
};

const validateResults = (action) => {
  const { type, payload: unsafePayload } = action;
  const payload = ensureCorrectData(unsafePayload);

  if (
    length(prop('result', payload)) === 0 &&
    oneOfLoadSingleDocumentType(type)
  ) {
    return {
      ...action,
      type: convertTypeToFailure(type),
      payload: getErrorObject(
        new ValidationError('No valid document left'),
        ERROR.ERROR_VALIDATING_DOC
      ),
    };
  }

  return {
    ...action,
    payload,
  };
};

const validatePagination = (action) => {
  const { payload: { total_page, page } = {} } = action;

  if (total_page > 0 && page > total_page) {
    return {
      type: GLOBAL_ERROR,
      payload: { message: 'Out of range', status: 404 },
    };
  }
  return action;
};

export default (/* store */) => (next) => (action) => {
  const { type } = action;
  if (oneOfLoadSuccessTypes(type)) {
    return next(validateResults(action));
  }
  if (oneOfLoadPaginateSuccessType(type)) {
    return next(validatePagination(action));
  }
  return next(action);
};
